import { Icon, Popup } from 'semantic-ui-react';

type FieldErrorPopupPropsType = {
    message: string;
};
const FieldErrorPopup = ({ message }: FieldErrorPopupPropsType) => {
    return <Popup on={'hover'} content={message} trigger={<Icon className='flex flex-align-center flex-justify-center' name="warning sign" color="red" />} />;
};

export default FieldErrorPopup;
